import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';
import {
	ContentType,
	HttpClient,
	RequestParams,
} from 'integration/generated/transactions/http-client';

const traceDetails = process.env.TRACE_DETAILS?.trim();

export const Department = <SecurityDataType = unknown>(http: HttpClient<SecurityDataType>) => {
	const findDepartment = (
		storeId: string,
		query?: {
			catentries?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (loggerCan('trace') && (!traceDetails || traceDetails.includes('findDepartment'))) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: {},
				methodName: 'findDepartment',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}

		return http.request<
			{
				departments: Record<string, string>;
			},
			void
		>({
			path: `/store/${storeId}/department/findbyIds`,
			method: 'GET',
			query,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};

	return {
		findDepartment,
	};
};
